import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("สร้างกลุ่ม")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("เพิ่มกลุ่มผู้ใช้")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ลบกลุ่ม")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("ผู้ใช้งานในกลุ่ม")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ตั้งค่ากลุ่มและสิทธิ")
const _hoisted_6 = { class: "flex mb-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("เพิ่มผู้ใช้")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("แก้ไข")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("ลบ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonInput = _resolveComponent("CommonInput")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_CommonForm = _resolveComponent("CommonForm")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_CommonModal = _resolveComponent("CommonModal")!
  const _component_CommonModalWithPreset = _resolveComponent("CommonModalWithPreset")!
  const _component_CommonButtonGroup = _resolveComponent("CommonButtonGroup")!
  const _component_PartOfListItem = _resolveComponent("PartOfListItem")!
  const _component_PanelList = _resolveComponent("PanelList")!
  const _component_CommonInputWithSearch = _resolveComponent("CommonInputWithSearch")!
  const _component_CommonRichTableWithAxios = _resolveComponent("CommonRichTableWithAxios")!
  const _component_CommonFormWithRoleEditor = _resolveComponent("CommonFormWithRoleEditor")!
  const _component_LayoutTabs = _resolveComponent("LayoutTabs")!
  const _component_LayoutFillPageWithEmptyState = _resolveComponent("LayoutFillPageWithEmptyState")!
  const _component_AdvancePageColumn = _resolveComponent("AdvancePageColumn")!

  return (_openBlock(), _createBlock(_component_AdvancePageColumn, { class: "list" }, {
    float: _withCtx(() => [
      _createVNode(_component_CommonModal, { ref: "createRoleModal" }, {
        default: _withCtx(() => [
          _createVNode(_component_Panel, { title: "สร้างกลุ่มผู้ใช้" }, {
            default: _withCtx(() => [
              _createVNode(_component_CommonForm, {
                mutation: _ctx.createRoleMutation,
                onDone: _cache[1] || (_cache[1] = ($event: any) => {_ctx.formCreate.name = ''; _ctx.$refs.createRoleModal.close();})
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CommonInput, {
                    type: "text",
                    label: "ชื่อกลุ่ม",
                    rules: "required|not_one_of:Super Admin,System Admin",
                    validationErrorMessage: "จำเป็นต้องกรอก",
                    modelValue: _ctx.formCreate.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formCreate.name) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_CommonButton, {
                    class: "mt-3",
                    type: "submit",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["mutation"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createVNode(_component_CommonModalWithPreset, {
        type: "confirm-delete",
        ref: "deleteRoleModal",
        onDone: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteRoleAction($event.id)))
      }, null, 512),
      _createVNode(_component_CommonModalWithPreset, {
        type: "confirm-delete",
        ref: "deleteUserModal",
        onDone: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteUserAction($event.id)))
      }, null, 512)
    ]),
    "left-panel": _withCtx(() => [
      _createVNode(_component_Panel, {
        class: "min-h-full",
        title: "กลุ่มผู้ใช้งาน"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_CommonButton, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$refs.createRoleModal.open())),
            icon: "vivat/icons/plus.png",
            level: "secondary"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_PanelList, {
            class: "mt-3 common-panel-list-with-role-display",
            items: _ctx.rolesResult
          }, {
            default: _withCtx((panelList) => [
              _createVNode(_component_PartOfListItem, {
                title: panelList.item.name,
                active: _ctx.$route.params.roleId == panelList.item.id,
                onClick: ($event: any) => (_ctx.$router.push({ name: 'SettingUserList', params: { roleId: panelList.item.id } }))
              }, {
                "primary-controls": _withCtx(() => [
                  (panelList.item.name !== 'Super Admin' && panelList.item.name !== 'System Admin')
                    ? (_openBlock(), _createBlock(_component_CommonButtonGroup, {
                        key: 0,
                        small: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CommonButton, {
                            level: "red-blend",
                            icon: "img/icons/icon_fast.svg#svgView(viewBox(264,48,24,24))",
                            iconClass: "w-6 h-6",
                            onClick: ($event: any) => {_ctx.$refs.deleteRoleModal.compose({ id: panelList.item.id, action: 'ลบ', entity: 'กลุ่มผู้ใช้' });}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["title", "active", "onClick"])
            ]),
            _: 1
          }, 8, ["items"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.$route.params.roleId)
        ? (_openBlock(), _createBlock(_component_Panel, {
            key: 0,
            title: `จัดการกลุ่ม ${(_ctx.getRoleDisplayFromRoute || {name: ''}).name}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Panel, null, {
                default: _withCtx(() => [
                  _createVNode(_component_LayoutTabs, null, {
                    "tab-user-title": _withCtx(() => [
                      _hoisted_4
                    ]),
                    "tab-permission-title": _withCtx(() => [
                      _hoisted_5
                    ]),
                    "tab-user": _withCtx(() => [
                      _createVNode(_component_Panel, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_CommonInputWithSearch, {
                              class: "flex-1",
                              modelValue: _ctx.search.text,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search.text) = $event)),
                              forName: "ด้วยชื่อ"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_CommonButton, {
                              class: "ml-3",
                              icon: "vivat/icons/plus.png",
                              small: "",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'SettingUserNew', params: { roleId: _ctx.$route.params.roleId } })))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(_component_CommonRichTableWithAxios, {
                            sort: { field: 'updatedAt', order: 'DESC' },
                            option: _ctx.userTableOption,
                            query: _ctx.getUsersQuery,
                            result: _ctx.getUsersResult,
                            variables: _ctx.usersListVariables
                          }, _createSlots({ _: 2 }, [
                            (_ctx.hasPermission('dotify.user.manage'))
                              ? {
                                  name: "column-_primaryControls-content",
                                  fn: _withCtx((row) => [
                                    _createVNode(_component_CommonButtonGroup, { small: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CommonButton, {
                                          level: "black-blend",
                                          icon: "/img/icons/icon_fast.svg#svgView(viewBox(240,48,24,24))",
                                          iconClass: "w-6 h-6",
                                          onClick: ($event: any) => (_ctx.$router.push({ name: 'SettingUserEdit', params: { id: row.item.id } }))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_8
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        (_ctx.hasPermission('dotify.user.manage') && _ctx.getRoleDisplayFromRoute.name != 'Super Admin' && row.item.id !== _ctx.me.id)
                                          ? (_openBlock(), _createBlock(_component_CommonButton, {
                                              key: 0,
                                              level: "red-blend",
                                              icon: "img/icons/icon_fast.svg#svgView(viewBox(264,48,24,24))",
                                              iconClass: "w-6 h-6",
                                              onClick: ($event: any) => (_ctx.openDeleteUserModal(row.item))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_9
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                }
                              : undefined
                          ]), 1032, ["option", "query", "result", "variables"])
                        ]),
                        _: 1
                      })
                    ]),
                    "tab-permission": _withCtx(() => [
                      _createVNode(_component_Panel, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_CommonFormWithRoleEditor, {
                            roleId: _ctx.$route.params.roleId,
                            module: []
                          }, null, 8, ["roleId"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]))
        : (_openBlock(), _createBlock(_component_LayoutFillPageWithEmptyState, {
            key: 1,
            class: "text-sm",
            forName: "กลุ่มผู้ใช้"
          }))
    ]),
    _: 1
  }))
}